
function BookCreator(url){

    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        fetch(url, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(err => {
                console.log(err.message);
                reject();
            });
    });
    /*
    useEffect(()=>{

    }, [url, jsonData]);
    //});
    return (
        resp
    );

     */
}


export default BookCreator;